import "./themes-5f0b3c3d.mjs";
import { z as h } from "./zIndices-d07533f3.mjs";
import "react/jsx-runtime";
import "react";
const a = {
  dropdown: {
    topAndBottom: 8,
    leftAndRight: 0
  },
  tooltip: { topAndBottom: 16, leftAndRight: 10 },
  popuptip: { topAndBottom: 20, leftAndRight: 10 },
  datepicker: { topAndBottom: 8, leftAndRight: 0 }
}, m = (t, l, n, i) => {
  const f = parseInt(
    i?.height?.replace("px", ""),
    10
  );
  let o = "";
  n === "dropdown" ? o = `${t.top - a[n].topAndBottom - f}px` : n === "datepicker" ? o = `${t.top - a[n].topAndBottom - l.height + 28}px` : o = `${t.top - a[n].topAndBottom - l.height}px`;
  const p = `${t.left + 50 * t.width / 100}px`, d = `${t.bottom + a[n].topAndBottom}px`, e = `${t.left - l.width - a[n].leftAndRight}px`, s = `${t.left + t.width + a[n].leftAndRight}px`, c = `${t.top + t.height / 2}px`;
  return {
    calculateTop: o,
    calculateLeft: p,
    calculateTopBottom: d,
    calculateLeftRight: e,
    calculateRight: s,
    topPosition: c
  };
}, x = (t, l, n, i, f) => {
  let o = {};
  const {
    calculateTop: p,
    calculateLeft: d,
    calculateTopBottom: e,
    calculateLeftRight: s,
    calculateRight: c,
    topPosition: u
  } = m(
    l,
    n,
    i,
    f
  );
  return t.startsWith("top") && (o = {
    top: p,
    left: d,
    bottom: "unset"
  }), t.startsWith("bottom") && (o = {
    top: e,
    left: d
  }), t.startsWith("left") && (o = {
    top: u,
    left: s,
    right: "unset"
  }), t.startsWith("right") && (o = {
    top: u,
    left: c
  }), t === "down_left" && (o = {
    top: e,
    left: `${l.left}px`
  }), t === "down_right" && (o = {
    top: e,
    left: `${l.right - n.width}px`
  }), t === "up_left" && (o = {
    top: p,
    left: `${l.left}px`,
    bottom: "unset"
  }), t === "up_right" && (o = {
    top: p,
    left: `${l.right - n.width}px`,
    bottom: "unset"
  }), o;
}, B = (t, l, n, i) => {
  if (!t.current || !l.current)
    return {};
  const f = t.current.getBoundingClientRect(), o = l.current.getBoundingClientRect(), p = getComputedStyle(l.current), d = x(
    n,
    f,
    o,
    i,
    p
  ), e = {
    tooltip: `${h.tooltip}`,
    dropdown: `${h.dropdown}`,
    popuptip: `${h.popover}`,
    datepicker: `${h.dropdown}`
  };
  return {
    ...d,
    zIndex: e[i]
  };
};
export {
  B as g
};
